import { Component, ViewChild } from '@angular/core';
import { Nav, Platform, MenuController } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { DataProvider } from '../providers/data/data';
import { ServicesProvider } from '../providers/services/services';
import { SimpleAlertProvider } from '../providers/simple-alert/simple-alert';
import { Insomnia } from '@ionic-native/insomnia';
import { ToastController } from 'ionic-angular';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  templateUrl: 'app.html'
})

export class MyApp {
	
	@ViewChild(Nav) nav: Nav;
    rootPage:any = 'SplashPage';
	 

    constructor(public platform: Platform, public statusBar: StatusBar, splashScreen: SplashScreen, public menu: MenuController, public services: ServicesProvider, public simpleAlert: SimpleAlertProvider, public dataService: DataProvider, private insomnia: Insomnia, public toastCtrl: ToastController, private domSanitizer: DomSanitizer) {
        platform.ready().then(() => {
            
			statusBar.hide();
            splashScreen.hide();
			
			let scope = this;
			
			platform.ready().then(() => {
			 window.addEventListener('keyboardWillShow', (ev) => {
				  	dataService.keyboardShown = true;
				});
				window.addEventListener('keyboardDidHide', () => {
				  	dataService.keyboardShown = false;
				});
			});
			
			
			
			platform.registerBackButtonAction(() => {
				if (scope.nav.getActive().name == "SingleGamePage"){
					scope.backListGames();
				}


			});
			
			this.insomnia.keepAwake()
			  .then(
				() => console.log('success insomnia'),
				() => console.log('error insomnia')
			  );
        });
    }

	 
	getCurrentPage() {
		if (typeof(this.nav.getActive()) == "undefined"){
			return "HomePage";
		}
		else {
			return this.nav.getActive().name;
		}
	}

	
	 
	 backListGames() {
		this.menu.close();     
		this.nav.setRoot("HomePage");
	}
	 
	

}





// WEBPACK FOOTER //
// ./src/app/app.component.ts